import { render, staticRenderFns } from "./CommissionManagement.vue?vue&type=template&id=71d200d9&scoped=true"
import script from "./CommissionManagement.vue?vue&type=script&lang=js"
export * from "./CommissionManagement.vue?vue&type=script&lang=js"
import style0 from "./CommissionManagement.vue?vue&type=style&index=0&id=71d200d9&prod&lang=scss&scoped=true"
import style1 from "./CommissionManagement.vue?vue&type=style&index=1&id=71d200d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d200d9",
  null
  
)

export default component.exports